// extracted by css-extract-rspack-plugin
export default {"descriptionSection":"_NZAQ"};